import Icon, { IconProps } from './Icon';

import TargetIcon from '../../../assets/icons/target.svg?react';

const Target: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <TargetIcon />
    </Icon>
  );
};

export default Target;
